import { toast } from 'react-toastify';
import { replaceOrAddById } from '../App/Helpers/store';

export const feedInitialState = {
	loading: false,
	items: [],
};

export const feedReducer = (state = feedInitialState, action) => {
	switch (action.type) {
		case 'FEED_ADD':
		case 'FEED_DELETE':
			return state;

		case 'FEED_EDITING':
		case 'FEED_LOADING':
			return {
				...state,
				loading: true,
			};

		case 'FEED_GET':
			return {
				...state,
				loading: false,
				items: action.payload.data.data,
			};

		case 'FEED_ERROR':
			toast.error('Virhe tietojen tallennuksessa');
			return {
				...state,
				loading: false,
			};
		case 'FEED_EDITED':
			toast.success('Tiedot tallennettu');
			return {
				...state,
				loading: false,
			};

		case 'FEEDITEM_SET_LOADING':
			let nitems = [...state.items];
			let nindex = nitems.findIndex((val) => {
				// eslint-disable-next-line eqeqeq
				return val.id == action.id;
			});
			if (nindex > -1) {
				nitems[nindex].loading = true;
			}

			return {
				...state,
				items: nitems,
				loading: false,
			};

		case 'ACK_SAVE_SUCCESS':
			var items = replaceOrAddById(
				[...state.items],
				action.payload.data.feedItem
			);

			return {
				...state,
				items,
				loading: false,
			};

		case 'FEEDITEM_GET':
			// eslint-disable-next-line no-redeclare
			var items = replaceOrAddById([...state.items], action.payload.data.data);

			return {
				...state,
				items,
				loading: false,
			};

		default:
			return state;
	}
};
